import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { summariseAssetTasks } from "routes/asset-register/plugins/regime-display/controller/summarise-asset-tasks"
import { keyBy } from "lib/keyBy"
import { Divider, Skeleton, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"
import { ClassificationSummary } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/criticality/classification-summary"
import { ListItemBox } from "lib/@components/ListItemBox"
import { formatTime } from "lib/format-time"
import { dummyResult } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/skills/dummy-result"

export function TaskCriticality() {
    const { regimeId, group, filters, search } = useBoundContext()
    const summary =
        summariseAssetTasks.useResults({
            regimeId,
            group,
            filters,
            search,
            summarise: ["classification"],
        }) ?? dummyResult
    const results = keyBy(summary, (c) => c.value[0])
    const totalMinutes = summary.reduce((a, c) => a + c.minutes ?? 0, 0)
    const totalTasks = summary.reduce((a, c) => a + c.count ?? 0, 0)

    return summary === dummyResult ? (
        <Skeleton animation="wave" sx={{ m: 2 }} variant="rounded" height={120} />
    ) : (
        <>
            <Stack direction="row" justifyContent="space-between" flexWrap="wrap" sx={{ p: 2 }}>
                <Repeat
                    list={Object.keys(ICON_FROM_CLASSIFICATION)}
                    item={<ClassificationSummary results={results} totalMinutes={totalMinutes} />}
                />
            </Stack>
            <Divider />
            <ListItemBox px={2} py={0.5}>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: "bold" }}>
                    {formatTime(totalMinutes)} per annum for {totalTasks.toLocaleString()}{" "}
                    {"task".pluralize(totalTasks)}
                </Typography>
            </ListItemBox>
        </>
    )
}
